import { each } from 'lodash-es';

/**
 * Adds script to body.
 *
 * @param src {string}
 * @param [dataset] {object}
 * @param [id] {string}
 * @param [attributes] {object}
 * @example injectScript(src, { camelCase: 'value' }, 'id', { 'name': 'value' }) -> <script async src=src data-camel-case="value" name="value" id=id></script>
 *
 */
export const injectScript = (src, dataset = {}, id, attributes = {}) =>
  new Promise((resolve, reject) => {
    const script = document.createElement('script');

    script.src = src;
    script.async = true;
    script.onload = resolve;
    script.onerror = reject;

    if (id) script.id = id;

    each(dataset, (dataValue, dataName) => {
      script.dataset[dataName] = dataValue;
    });

    each(attributes, (attributeValue, attributeName) => {
      script.setAttribute(attributeName, attributeValue);
    });

    document.body.appendChild(script);
  });
